import React from "react";
import Ripples from "react-ripples"; 
import acercaImg from "../assets/img/hoyvemoslogo.svg";

const AcercaDe = () => {
  return (
    <section className="relative bg-gray-100 overflow-visible">
      {/* Top SVG Shape */}
      <div className="absolute top-0 left-0 w-full -z-10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
        >
          <path className="fill-current text-gray-100" d="M0,6V0h1000v100L0,6z"></path>
        </svg>
      </div>

      <div className="container mx-auto flex flex-col md:flex-row items-center py-16 px-6">
        {/* Imagen */}
        <div className="w-full md:w-1/3 flex justify-center">
          <img
            src={acercaImg}
            alt="Acerca de nosotros"
            className="max-w-[250px] md:max-w-[300px] mx-auto"
          />
        </div>

        {/* Contenido */}
        <div className="w-full md:w-2/3 mt-8 md:mt-0 md:pl-10 text-center md:text-left">
          <h3 className="text-lg font-semibold text-blue-600">Acerca de</h3>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Nuestra Historia
          </h2>
          <p className="text-base text-gray-700 mb-4 text-justify">
            En <strong>¡HOY VEMOS!</strong>, trabajamos para ofrecerte una asistencia técnica personalizada 
            y sin complicaciones para acceder a plataformas gestionadas por terceros. 
            Nuestro compromiso es ofrecer un servicio transparente, de alta calidad y adaptado a las 
            necesidades únicas de cada usuario.
          </p>
          <p className="text-base text-gray-700 mb-4 text-justify">
            Formamos un equipo apasionado por la excelencia y centrado en la experiencia del cliente, 
            facilitando soluciones accesibles, efectivas y diseñadas para simplificar tu día a día.
          </p>
          <Ripples color="rgba(255, 255, 255, 0.3)" during={400}>
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-md text-lg font-medium transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow hover:shadow-lg"
            >
              Conoce más
            </button>
          </Ripples>
        </div>
      </div>

      {/* Bottom SVG Shape */}
      <div className="absolute bottom-0 left-0 w-full rotate-180 -z-10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
        >
          <path className="fill-current text-gray-100" d="M0,6V0h1000v100L0,6z"></path>
        </svg>
      </div>
    </section>
  );
};

export default AcercaDe;
